<template>
  <div class="aspect-container aspect-container-1-1">
    <div class="aspect-content">
      <div class="tile" @click="clickGroup()">
        <div class="snipe" :class="snipeColorClass">{{group.snipeText}}</div>
        <div class="tile-image-container">
          <img class="tile-image" :src="group.images[0].smallUrl" />
        </div>
        <div class="tile-text-container">
          <div class="tile-text">{{group.title}}</div>
        </div>
        <div v-if="group.barcodeUrl" class="barcode-container">
          <img class="barcode-img" :src="group.barcodeUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    group: Object,
    index: Number
  },
  data: () => ({}),
  methods: {
    clickGroup: function() {
      this.$router.push(
        `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Groups/${this.group.pageNumber}`
      );
    }
  },
  computed: {
    snipeColorClass() {
      return this.group.snipeColor == "snipe.color.platinum"
        ? "snipe-platinum"
        : this.group.snipeColor == "snipe.color.gold"
        ? "snipe-gold"
        : this.group.snipeColor == "snipe.color.silver"
        ? "snipe-silver"
        : "";
    }
  }
};
</script>

<style lang="scss" scoped>
</style>